// extracted by mini-css-extract-plugin
export default {"highlightedText":"sC6UxPqqedIvZt0eE6gzOw=="};